export default {
  SearchPlaceholder: 'Search acceleration ip/domain name',
  ClientName: 'Client Name',
  AcceleratedIP: 'Accelerated IP',
  SpeedUpDomainName: 'Speed ​​up domain name',
}